// Site de base seulement : ne jamais réutiliser dp_rules_accepted_<ligue> (embeds).
const acceptanceKey = (userId: number, leagueId: number) =>
  `dp_base_rules_accepted_${userId}_${leagueId}`;

// Si le navigateur refuse localStorage, conserver l'accord pendant cette session
// pour permettre la navigation sans boucle. Une actualisation redemandera l'accord.
const sessionAcceptances = new Set<string>();

export function hasAcceptedBaseLeagueRules(userId: number, leagueId: number): boolean {
  const key = acceptanceKey(userId, leagueId);
  try {
    return localStorage.getItem(key) === 'true' || sessionAcceptances.has(key);
  } catch {
    return sessionAcceptances.has(key);
  }
}

export function acceptBaseLeagueRules(userId: number, leagueId: number): void {
  const key = acceptanceKey(userId, leagueId);
  try {
    localStorage.setItem(key, 'true');
  } catch {
    sessionAcceptances.add(key);
  }
}
